// REFERENCES

jQuery(document).ready(function($){

  $('.c-references--btn').click(function() {
    $(this).toggleClass('active');
    $(this).text(($(this).text() == 'More References') ? 'Less References' : 'More References').fadeIn();
    $('.c-references').toggleClass('active');
  });

  var listItemsCount = $(".c-references > ul > li").length + $(".c-references > ol > li").length;

  if (listItemsCount < 4) {
    $('.c-references--btn').hide();
  }
  
});
